import { type ReactElement } from 'react'
import { Text } from '@mantine/core'
import { useTranslation } from '@front/model'
import { type SearchResult } from './useRecentResults'
import classes from './spotlight.module.css'

export const SearchResultDetails = ({ item }: { item: SearchResult }): ReactElement => {
  const { t } = useTranslation()
  return (
    <span className={classes.entityBody}>
      <span className={classes.actionLabel}>{item.description}</span>
      <span className={classes.actionDescription}>
        <SearchResultSubtitle item={item} />
        {'isDeleted' in item && item.isDeleted && (
          <>
            {' '}
            ·{' '}
            <Text component='span' inherit c='red'>
              {t('In Trash')}
            </Text>
          </>
        )}
      </span>
    </span>
  )
}

const SearchResultSubtitle = ({ item }: { item: SearchResult }): ReactElement => {
  const { t } = useTranslation()
  if (item.type === 'Destination') return <>{item.subtitle}</>
  if (item.type === 'Account') return <>{item.subtitle}</>
  if (item.type === 'Company') {
    const color = item.state === 'active' ? 'green' : 'red'
    const label = item.state === 'active' ? 'Active' : 'Suspended'
    return (
      <>
        {t(item.type)} ·{' '}
        <Text component='span' inherit c={color}>
          {t(label)}
        </Text>
      </>
    )
  }
  return (
    <>
      {t(item.type)}
      {item.subtitle && ` · ${item.subtitle}`}
    </>
  )
}
